import {
  PermissionsPermissionType as Data,
  PermissionsPermissionTypeCollection as Collection,
} from '@/typings/api/PermissionsPermissionType'

import { BaseApiAuth } from '@/api/BaseApiAuth'


export class PermissionsPermissionTypesApi extends BaseApiAuth<Data, Collection> {
  protected readonly endpoint = 'permissions/permission-types';
}
